import React from 'react';
import { Alert, Button, Snackbar } from '@mui/material';

const LayoutSnackbars = ({
  softRefreshSnackbar,
  onSoftClose,
  onSoftApply,
  snackbar,
  onClose,
}) => (
  <>
    <Snackbar
      open={softRefreshSnackbar.open}
      autoHideDuration={4000}
      onClose={onSoftClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onSoftClose}
        severity="info"
        variant="filled"
        sx={{ width: '100%' }}
        action={
          <Button color="inherit" size="small" onClick={onSoftApply}>
            Refresh view
          </Button>
        }
      >
        {softRefreshSnackbar.message || 'New data available - refresh view.'}
      </Alert>
    </Snackbar>
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  </>
);

export default LayoutSnackbars;
